import ProcessLabel from './EcallProcessLabel';
import {motion, useAnimation, useInView} from 'framer-motion';
import {useEffect, useRef, useState} from 'react';

const BLOCK_INIT = {
  fill: '#E0E0E0',
  color: '#525252',
}

const BLOCK_TRANSITION = {
  duration: 0.25,
  ease: 'easeOut',
}

export default function EcallProcessPc() {

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const blockVariants = {
    init: BLOCK_INIT,
    block0: {
      fill: '#0391F0',
      color: '#FFF',
      transition: {
        duration: 0.25,
        ease: 'easeOut',

      }
    },
    block1: {
      fill: '#E0E0E0',
      color: '#A8A8A8',
      transition: {
        duration: 0.25,
        ease: 'easeOut',

      }
    },
    block2: {
      fill: '#0084DB',
      color: '#FFF',
      transition: {
        duration: 0.25,
        ease: 'easeOut',

      }
    },
    block3: {
      fill: '#0071BC',
      color: '#FFF',
      transition: {
        duration: 0.25,
        ease: 'easeOut',
      }
    },
    block4: {
      fill: '#E0E0E0',
      color: '#A8A8A8',
      transition: {
        duration: 0.25,
        ease: 'easeOut',
      }
    }
  }

  const descriptionVariants = {
    init: {
      opacity: 0,
    },
    description0: {
      opacity: 1
    },
    description1: {
      opacity: 1
    },
    description2: {
      opacity: 1
    },
    description3: {
      opacity: 1
    },
  }

  const blockControls = [
    useAnimation(),
    useAnimation(),
    useAnimation(),
    useAnimation(),
    useAnimation(),
  ];

  const lastBlockControl = useAnimation();
  const lastBlockInnerControl = useAnimation();

  const descriptionControls = [
    useAnimation(),
    useAnimation(),
    useAnimation(),
    useAnimation(),
  ];

  useEffect(() => {
    if (isInView) {
      setTimeout(() => animateProcess(), 500);
    }
  }, [isInView]);

  const animateInit = () => {
    document.getElementById('block-number-2').textContent = '3';
    document.getElementById('block-number-3').textContent = '4';

    lastBlockControl.start({
      opacity: 0,
      transition: {
        duration: 0.25,
        ease: 'easeOut',
      }
    });
    lastBlockInnerControl.start({
      width: '502px',
      transition: {
        duration: 1,
        ease: 'easeOut',
      }
    });

    for (let i = 0; i < blockControls.length; i++) {
      blockControls[blockControls.length - i - 1].start({
        ...BLOCK_INIT,
        transition: {
          duration: 1,
          ease: 'easeOut',
          delay: 0.1 * i
        }
      });
    }

    for (let i = 0; i < descriptionControls.length; i++) {
      descriptionControls[descriptionControls.length - i - 1].start('init');
    }
  }

  const animateProcess = async () => {
    // 1. 사고 발생(0) 블럭 활성화
    await blockControls[0].start('block0');

    // 2. 사고 접수(2) 블럭 활성화, 3번에서 2번으로 번경
    await blockControls[2].start('block2');
    document.getElementById('block-number-2').textContent = '2';

    // 3. 단축 설명(0) 노출, 사고 신고전화 블럭(1) 비활성화
    await descriptionControls[0].start('description0');
    await blockControls[1].start('block1');

    // 4. 사이 설명(1) 노출
    await descriptionControls[1].start('description1');

    // 5. 구급자 출동 (3) 활성화, 4번에서 3번으로 번경
    await blockControls[3].start('block3');
    document.getElementById('block-number-3').textContent = '3';

    // 6. 설명 (2) 노출
    await descriptionControls[2].start('description2');

    // 7. 마지막 블럭 노출 및 사이즈 줄어듬
    await lastBlockControl.start({
      opacity: 1,
      transition: {
        duration: 0.25,
        ease: 'easeOut',
      }
    });
    await lastBlockInnerControl.start({
      width: '150px',
      transition: {
        duration: 1,
        ease: 'easeOut',
      }
    });

    // 8. 블럭(4) 비활성화, 설명 (3) 슬라이드 노출
    blockControls[4].start('block4');
    await descriptionControls[3].start('description3');
  }

  const clickRefresh = async () => {
    animateInit();

    setTimeout(() => animateProcess(), 1000);
  }

  const ProcessBlock = ({ index, number, title }) =>  {
    return (
      <div className="relative w-[189px] h-[100px]"
           style={{transform: `translateX(-${index * 14}px)`}}
      >
        <motion.div
          className="absolute w-full h-full flex flex-col justify-center items-center z-[1] text-center text-heading2"
          initial='init'
          animate={blockControls[index]}
          variants={blockVariants}
        >
          <div id={`block-number-${index}`}>{number}</div>
          <div>{title}</div>
        </motion.div>


        <svg width="189" height="100" viewBox="0 0 189 100" fill="none" xmlns="http://www.w3.org/2000/svg">

          <motion.path
            d="M168.662 0.5L188.462 50L168.662 99.5H0.738281L20.4639 50.1855L20.5381 50L20.4639 49.8145L0.738281 0.5H168.662Z"
            initial='init'
            animate={blockControls[index]}
            variants={blockVariants}
          />
        </svg>
      </div>
    )
  }

  return (
    <section ref={ref} className='w-full max-w-[1580px] mt-[320px] mx-auto'>
      <div className='text-center text-display2 text-label-500'>사고 신고 개선 프로세스</div>

      <div className='mt-[80px] p-[60px] bg-[#FAFAFA] rounded-[20px]'>
        {/* TOP */}
        <div className='flex justify-between'>
          <ProcessLabel/>

          <div className='text-heading3 text-label-300' >
            <div className='flex gap-x-[8px] cursor-pointer' onClick={clickRefresh}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4 12C4 13.5822 4.46919 15.129 5.34824 16.4446C6.22729 17.7602 7.47672 18.7855 8.93853 19.391C10.4003 19.9965 12.0089 20.155 13.5607 19.8463C15.1126 19.5376 16.538 18.7757 17.6568 17.6568C18.7757 16.538 19.5376 15.1126 19.8463 13.5607C20.155 12.0089 19.9965 10.4003 19.391 8.93853C18.7855 7.47672 17.7602 6.22729 16.4446 5.34824C15.129 4.46919 13.5822 4 12 4C9.76351 4.00841 7.61686 4.88109 6.00889 6.43555L4 8.44444M4 8.44444V4M4 8.44444H8.44444"
                  stroke="#393939" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              개선된 프로세스 다시보기
            </div>
          </div>
        </div>

        {/* MIDDLE */}
        <div 
          className='overflow-x-auto mt-[115px]'
          style={{ zoom: Math.min(window.innerWidth / 1580, 1) }}
        >
          <div className='w-[1245px] mx-auto'>
            {/* TOP */}
            <div className="flex items-end">
              <motion.div
                className="w-[240px] ml-[140px] mb-[5px] flex flex-col items-center gap-y-[8px]"
                initial="init"
                variants={descriptionVariants}
                animate={descriptionControls[0]}
              >
                <div className="text-heading2 font-bold text-label-300">프로세스 단축</div>
                <svg width="296" height="44" viewBox="0 0 296 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M296 40L290.142 30.0493L284.453 40.0979L296 40ZM151.262 1.00679L151.268 0.00680923L151.262 1.00679ZM11.3333 38.0355C11.3333 35.09 8.94553 32.7022 6 32.7022C3.05447 32.7022 0.666656 35.09 0.666656 38.0355C0.666656 40.9811 3.05447 43.3689 6 43.3689C8.94553 43.3689 11.3333 40.9811 11.3333 38.0355ZM288.349 35.7682L288.82 34.886C287.099 33.9674 285.37 33.0663 283.633 32.1829L283.18 33.0742L282.726 33.9655C284.452 34.843 286.169 35.738 287.878 36.6503L288.349 35.7682ZM277.958 30.4829L278.394 29.5828C276.638 28.7331 274.875 27.9012 273.104 27.087L272.687 27.9956L272.269 28.9041C274.027 29.7128 275.779 30.5391 277.523 31.383L277.958 30.4829ZM267.367 25.6131L267.766 24.6964C265.979 23.917 264.184 23.1555 262.383 22.4119L262.001 23.3363L261.62 24.2607C263.409 24.9992 265.192 25.7556 266.967 26.5297L267.367 25.6131ZM256.591 21.166L256.954 20.2342C255.137 19.5261 253.314 18.8361 251.484 18.1643L251.139 19.103L250.795 20.0417C252.612 20.709 254.423 21.3944 256.228 22.0977L256.591 21.166ZM245.648 17.1481L245.974 16.2028C244.131 15.5671 242.281 14.9496 240.426 14.3505L240.119 15.3022L239.812 16.2538C241.654 16.8488 243.491 17.4621 245.322 18.0935L245.648 17.1481ZM234.555 13.5657L234.843 12.6082C232.976 12.0458 231.104 11.5018 229.227 10.9764L228.957 11.9393L228.688 12.9023C230.552 13.4242 232.412 13.9645 234.266 14.5232L234.555 13.5657ZM223.329 10.4238L223.579 9.45568C221.692 8.96741 219.8 8.49772 217.903 8.04671L217.671 9.01958L217.44 9.99246C219.324 10.4404 221.204 10.907 223.078 11.3919L223.329 10.4238ZM211.987 7.72722L212.199 6.74997C210.295 6.33657 208.385 5.94188 206.472 5.56598L206.279 6.54723L206.086 7.52847C207.987 7.90183 209.883 8.29386 211.775 8.70448L211.987 7.72722ZM200.549 5.47999L200.722 4.49514C198.803 4.15718 196.879 3.83805 194.952 3.53783L194.798 4.52591L194.644 5.51399C196.558 5.81219 198.469 6.12916 200.375 6.46484L200.549 5.47999ZM189.03 3.68536L189.165 2.69444C187.233 2.43244 185.299 2.18938 183.362 1.96532L183.247 2.95871L183.132 3.95208C185.056 4.17463 186.978 4.41605 188.896 4.67628L189.03 3.68536ZM177.45 2.34615L177.546 1.3507C175.606 1.16501 173.663 0.998344 171.718 0.85078L171.643 1.84792L171.567 2.84505C173.499 2.99162 175.428 3.15716 177.355 3.34159L177.45 2.34615ZM165.826 1.4642L165.882 0.465767C163.937 0.356667 161.989 0.266663 160.04 0.195831L160.003 1.19517L159.967 2.19451C161.903 2.26487 163.838 2.35426 165.77 2.46263L165.826 1.4642ZM154.177 1.04089L154.193 0.0410271C153.219 0.024826 152.244 0.0134163 151.268 0.00680923L151.262 1.00679L151.255 2.00676C152.224 2.01332 153.192 2.02466 154.16 2.04075L154.177 1.04089ZM151.262 1.00679L151.268 0.00680923C150.293 0.000202179 149.318 -0.00159836 148.343 0.00139999L148.346 1.0014L148.35 2.00139C149.318 1.99841 150.286 2.0002 151.255 2.00676L151.262 1.00679ZM142.518 1.07674L142.495 0.0769958C140.545 0.121418 138.596 0.185036 136.649 0.26778L136.692 1.26688L136.734 2.26598C138.668 2.18379 140.604 2.1206 142.541 2.07648L142.518 1.07674ZM130.87 1.57178L130.808 0.573715C128.861 0.694927 126.917 0.83527 124.974 0.994675L125.056 1.99133L125.138 2.98798C127.067 2.82964 128.999 2.69025 130.932 2.56985L130.87 1.57178ZM119.251 2.52534L119.15 1.53049C117.21 1.72829 115.272 1.94514 113.338 2.18097L113.459 3.17362L113.58 4.16627C115.501 3.93203 117.426 3.71665 119.353 3.52018L119.251 2.52534ZM107.679 3.936L107.539 2.94592C105.608 3.22002 103.68 3.51308 101.756 3.82502L101.916 4.81213L102.076 5.79924C103.987 5.4894 105.902 5.19832 107.82 4.92607L107.679 3.936ZM96.1713 5.80168L95.9919 4.81792C94.0735 5.16787 92.159 5.53667 90.2486 5.92425L90.4474 6.90428L90.6462 7.88432C92.5437 7.49936 94.4454 7.13304 96.3508 6.78545L96.1713 5.80168ZM84.7462 8.11956L84.5281 7.14363C82.6251 7.56893 80.7266 8.01295 78.8327 8.47561L79.07 9.44704L79.3073 10.4185C81.1884 9.95893 83.0742 9.51791 84.9643 9.09548L84.7462 8.11956ZM73.4212 10.8862L73.1648 9.91966C71.2803 10.4196 69.4007 10.9382 67.5264 11.4753L67.8019 12.4366L68.0773 13.3979C69.939 12.8645 71.8059 12.3494 73.6776 11.8528L73.4212 10.8862ZM62.2142 14.0975L61.9198 13.1419C60.0567 13.7158 58.1991 14.3081 56.3473 14.9188L56.6605 15.8685L56.9737 16.8182C58.813 16.2116 60.6581 15.6233 62.5086 15.0532L62.2142 14.0975ZM51.1428 17.7487L50.8109 16.8054C48.9721 17.4524 47.1393 18.1176 45.3128 18.8011L45.6633 19.7376L46.0138 20.6742C47.8279 19.9954 49.6483 19.3347 51.4747 18.6921L51.1428 17.7487ZM40.224 21.8345L39.8551 20.905C38.0435 21.6241 36.2385 22.3612 34.4404 23.1163L34.8276 24.0383L35.2148 24.9603C37.0008 24.2103 38.7935 23.4781 40.593 22.764L40.224 21.8345ZM29.4757 26.3485L29.0704 25.4343C27.2887 26.2244 25.5142 27.0323 23.7471 27.8581L24.1705 28.7641L24.5938 29.67C26.3489 28.8498 28.1115 28.0473 29.8811 27.2626L29.4757 26.3485ZM18.9138 31.2843L18.4726 30.3869C16.7238 31.2467 14.9827 32.1243 13.2496 33.0194L13.7085 33.9079L14.1674 34.7964C15.8888 33.9073 17.6181 33.0357 19.3551 32.1817L18.9138 31.2843ZM8.55621 36.634L8.0798 35.7548C7.22275 36.2192 6.3678 36.688 5.51489 37.1611L6 38.0355L6.48511 38.91C7.33218 38.4401 8.1814 37.9745 9.03262 37.5133L8.55621 36.634ZM296 40L290.142 30.0493L284.453 40.0979L296 40ZM151.262 1.00679L151.268 0.00680923L151.262 1.00679ZM11.3333 38.0355C11.3333 35.09 8.94553 32.7022 6 32.7022C3.05447 32.7022 0.666656 35.09 0.666656 38.0355C0.666656 40.9811 3.05447 43.3689 6 43.3689C8.94553 43.3689 11.3333 40.9811 11.3333 38.0355ZM288.349 35.7682L288.82 34.886C287.099 33.9674 285.37 33.0663 283.633 32.1829L283.18 33.0742L282.726 33.9655C284.452 34.843 286.169 35.738 287.878 36.6503L288.349 35.7682ZM277.958 30.4829L278.394 29.5828C276.638 28.7331 274.875 27.9012 273.104 27.087L272.687 27.9956L272.269 28.9041C274.027 29.7128 275.779 30.5391 277.523 31.383L277.958 30.4829ZM267.367 25.6131L267.766 24.6964C265.979 23.917 264.184 23.1555 262.383 22.4119L262.001 23.3363L261.62 24.2607C263.409 24.9992 265.192 25.7556 266.967 26.5297L267.367 25.6131ZM256.591 21.166L256.954 20.2342C255.137 19.5261 253.314 18.8361 251.484 18.1643L251.139 19.103L250.795 20.0417C252.612 20.709 254.423 21.3944 256.228 22.0977L256.591 21.166ZM245.648 17.1481L245.974 16.2028C244.131 15.5671 242.281 14.9496 240.426 14.3505L240.119 15.3022L239.812 16.2538C241.654 16.8488 243.491 17.4621 245.322 18.0935L245.648 17.1481ZM234.555 13.5657L234.843 12.6082C232.976 12.0458 231.104 11.5018 229.227 10.9764L228.957 11.9393L228.688 12.9023C230.552 13.4242 232.412 13.9645 234.266 14.5232L234.555 13.5657ZM223.329 10.4238L223.579 9.45568C221.692 8.96741 219.8 8.49772 217.903 8.04671L217.671 9.01958L217.44 9.99246C219.324 10.4404 221.204 10.907 223.078 11.3919L223.329 10.4238ZM211.987 7.72722L212.199 6.74997C210.295 6.33657 208.385 5.94188 206.472 5.56598L206.279 6.54723L206.086 7.52847C207.987 7.90183 209.883 8.29386 211.775 8.70448L211.987 7.72722ZM200.549 5.47999L200.722 4.49514C198.803 4.15718 196.879 3.83805 194.952 3.53783L194.798 4.52591L194.644 5.51399C196.558 5.81219 198.469 6.12916 200.375 6.46484L200.549 5.47999ZM189.03 3.68536L189.165 2.69444C187.233 2.43244 185.299 2.18938 183.362 1.96532L183.247 2.95871L183.132 3.95208C185.056 4.17463 186.978 4.41605 188.896 4.67628L189.03 3.68536ZM177.45 2.34615L177.546 1.3507C175.606 1.16501 173.663 0.998344 171.718 0.85078L171.643 1.84792L171.567 2.84505C173.499 2.99162 175.428 3.15716 177.355 3.34159L177.45 2.34615ZM165.826 1.4642L165.882 0.465767C163.937 0.356667 161.989 0.266663 160.04 0.195831L160.003 1.19517L159.967 2.19451C161.903 2.26487 163.838 2.35426 165.77 2.46263L165.826 1.4642ZM154.177 1.04089L154.193 0.0410271C153.219 0.024826 152.244 0.0134163 151.268 0.00680923L151.262 1.00679L151.255 2.00676C152.224 2.01332 153.192 2.02466 154.16 2.04075L154.177 1.04089ZM151.262 1.00679L151.268 0.00680923C150.293 0.000202179 149.318 -0.00159836 148.343 0.00139999L148.346 1.0014L148.35 2.00139C149.318 1.99841 150.286 2.0002 151.255 2.00676L151.262 1.00679ZM142.518 1.07674L142.495 0.0769958C140.545 0.121418 138.596 0.185036 136.649 0.26778L136.692 1.26688L136.734 2.26598C138.668 2.18379 140.604 2.1206 142.541 2.07648L142.518 1.07674ZM130.87 1.57178L130.808 0.573715C128.861 0.694927 126.917 0.83527 124.974 0.994675L125.056 1.99133L125.138 2.98798C127.067 2.82964 128.999 2.69025 130.932 2.56985L130.87 1.57178ZM119.251 2.52534L119.15 1.53049C117.21 1.72829 115.272 1.94514 113.338 2.18097L113.459 3.17362L113.58 4.16627C115.501 3.93203 117.426 3.71665 119.353 3.52018L119.251 2.52534ZM107.679 3.936L107.539 2.94592C105.608 3.22002 103.68 3.51308 101.756 3.82502L101.916 4.81213L102.076 5.79924C103.987 5.4894 105.902 5.19832 107.82 4.92607L107.679 3.936ZM96.1713 5.80168L95.9919 4.81792C94.0735 5.16787 92.159 5.53667 90.2486 5.92425L90.4474 6.90428L90.6462 7.88432C92.5437 7.49936 94.4454 7.13304 96.3508 6.78545L96.1713 5.80168ZM84.7462 8.11956L84.5281 7.14363C82.6251 7.56893 80.7266 8.01295 78.8327 8.47561L79.07 9.44704L79.3073 10.4185C81.1884 9.95893 83.0742 9.51791 84.9643 9.09548L84.7462 8.11956ZM73.4212 10.8862L73.1648 9.91966C71.2803 10.4196 69.4007 10.9382 67.5264 11.4753L67.8019 12.4366L68.0773 13.3979C69.939 12.8645 71.8059 12.3494 73.6776 11.8528L73.4212 10.8862ZM62.2142 14.0975L61.9198 13.1419C60.0567 13.7158 58.1991 14.3081 56.3473 14.9188L56.6605 15.8685L56.9737 16.8182C58.813 16.2116 60.6581 15.6233 62.5086 15.0532L62.2142 14.0975ZM51.1428 17.7487L50.8109 16.8054C48.9721 17.4524 47.1393 18.1176 45.3128 18.8011L45.6633 19.7376L46.0138 20.6742C47.8279 19.9954 49.6483 19.3347 51.4747 18.6921L51.1428 17.7487ZM40.224 21.8345L39.8551 20.905C38.0435 21.6241 36.2385 22.3612 34.4404 23.1163L34.8276 24.0383L35.2148 24.9603C37.0008 24.2103 38.7935 23.4781 40.593 22.764L40.224 21.8345ZM29.4757 26.3485L29.0704 25.4343C27.2887 26.2244 25.5142 27.0323 23.7471 27.8581L24.1705 28.7641L24.5938 29.67C26.3489 28.8498 28.1115 28.0473 29.8811 27.2626L29.4757 26.3485ZM18.9138 31.2843L18.4726 30.3869C16.7238 31.2467 14.9827 32.1243 13.2496 33.0194L13.7085 33.9079L14.1674 34.7964C15.8888 33.9073 17.6181 33.0357 19.3551 32.1817L18.9138 31.2843ZM8.55621 36.634L8.0798 35.7548C7.22275 36.2192 6.3678 36.688 5.51489 37.1611L6 38.0355L6.48511 38.91C7.33218 38.4401 8.1814 37.9745 9.03262 37.5133L8.55621 36.634Z"
                    fill="#0391F0"
                  />
                </svg>
              </motion.div>

              <motion.div
                className="ml-[497px] translate-y-[4px]"
                initial='init'
                variants={descriptionVariants}
                animate={descriptionControls[3]}
              >
                <div
                  className="w-[309px] h-[144px] flex flex-col justify-center border-dashed border-x-2 border-primary-100"
                  style={{background: 'linear-gradient(180deg, rgba(3, 145, 240, 0.00) 0%, rgba(3, 145, 240, 0.12) 100%'}}
                >
                  <div className="text-center text-title3 text-primary-400">16분 14초 이상</div>
                  <div className="text-center text-heading3 text-label-300">구급대 현장 도착 시간 단축</div>
                </div>
              </motion.div>
            </div>

            {/* MIDDLE */}
            <div className="flex">
              <ProcessBlock index={0} number={1} title="사고 발생"/>
              <ProcessBlock index={1} number={2} title="사고 신고전화"/>
              <ProcessBlock index={2} number={3} title="사고 접수"/>
              <ProcessBlock index={3} number={4} title="구급차 출동"/>

              <div className="relative w-[543px] h-[100px]" style={{transform: `translateX(-56px)`}}>
                <motion.div
                  className="absolute w-full h-full pr-[50px] flex justify-end items-center z-[1] text-center text-heading2"
                  initial="init"
                  variants={blockVariants}
                  animate={blockControls[4]}
                >
                  5<br/>
                  구급대 현장 도착
                </motion.div>

                <svg width="543" height="100" viewBox="0 0 543 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0H512.749L543 50L512.749 100H0L20 50L0 0Z" fill="url(#paint0_linear_51482_597)"/>
                  <defs>
                    <linearGradient id="paint0_linear_51482_597" x1="2.12985" y1="50" x2="545.13" y2="50"
                                    gradientUnits="userSpaceOnUse">
                      <stop stopColor="#E0E0E0" stopOpacity="0.3"/>
                      <stop offset="1" stopColor="#E0E0E0"/>
                    </linearGradient>
                  </defs>
                </svg>
              </div>

              <motion.div
                className="flex h-[100px] translate-x-[-601px]"
                initial={{opacity: 0}}
                animate={lastBlockControl}
              >
                <svg width="22" height="100" viewBox="0 0 22 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0L20 50L0 100H22V0H21H0Z" fill="#0062A4"/>
                  <path d="M0 0L20 50L0 100H22V0H21H0Z" fill="#0062A4"/>
                </svg>

                <motion.div
                  className="h-[100px] bg-primary-400 translate-x-[-1px] flex justify-end items-center text-white text-center text-heading2"
                  initial={{width: '502px'}}
                  animate={lastBlockInnerControl}
                >
                  4<br/>
                  구급대 현장 도착
                </motion.div>

                <svg className="translate-x-[-2px]" width="33" height="100" viewBox="0 0 33 100" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 100H3L33 50L2.8 0H0V47.5V100Z" fill="#0062A4"/>
                </svg>
              </motion.div>
            </div>

            {/* BOTTOM */}
            <div className="flex">
              <motion.div
                className="ml-[345px]"
                initial="init"
                animate={descriptionControls[1]}
                variants={descriptionVariants}
              >
                <svg width="6" height="147" viewBox="0 0 6 147" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2.99999 141.333C1.52723 141.333 0.333326 142.527 0.333326 144C0.333326 145.473 1.52723 146.667 2.99999 146.667C4.47275 146.667 5.66666 145.473 5.66666 144C5.66666 142.527 4.47275 141.333 2.99999 141.333ZM3 0L2.5 -1.96701e-08L2.5 3L3 3L3.5 3L3.5 1.96701e-08L3 0ZM3 9L2.5 9L2.5 15L3 15L3.5 15L3.5 9L3 9ZM3 21L2.5 21L2.5 27L3 27L3.5 27L3.5 21L3 21ZM3 33L2.5 33L2.5 39L3 39L3.5 39L3.5 33L3 33ZM3 45L2.5 45L2.5 51L3 51L3.5 51L3.5 45L3 45ZM3 57L2.5 57L2.5 63L3 63L3.5 63L3.5 57L3 57ZM3 69L2.5 69L2.5 75L3 75L3.5 75L3.5 69L3 69ZM3 81L2.5 81L2.5 87L3 87L3.5 87L3.5 81L3 81ZM3 93L2.5 93L2.5 99L3 99L3.5 99L3.5 93L3 93ZM2.99999 105L2.49999 105L2.49999 111L2.99999 111L3.49999 111L3.49999 105L2.99999 105ZM2.99999 117L2.49999 117L2.49999 123L2.99999 123L3.49999 123L3.49999 117L2.99999 117ZM2.99999 129L2.49999 129L2.49999 135L2.99999 135L3.49999 135L3.49999 129L2.99999 129ZM2.99999 141L2.49999 141L2.49999 144L2.99999 144L3.49999 144L3.49999 141L2.99999 141ZM2.99999 141.333C1.52723 141.333 0.333326 142.527 0.333326 144C0.333326 145.473 1.52723 146.667 2.99999 146.667C4.47275 146.667 5.66666 145.473 5.66666 144C5.66666 142.527 4.47275 141.333 2.99999 141.333ZM3 0L2.5 -1.96701e-08L2.5 3L3 3L3.5 3L3.5 1.96701e-08L3 0ZM3 9L2.5 9L2.5 15L3 15L3.5 15L3.5 9L3 9ZM3 21L2.5 21L2.5 27L3 27L3.5 27L3.5 21L3 21ZM3 33L2.5 33L2.5 39L3 39L3.5 39L3.5 33L3 33ZM3 45L2.5 45L2.5 51L3 51L3.5 51L3.5 45L3 45ZM3 57L2.5 57L2.5 63L3 63L3.5 63L3.5 57L3 57ZM3 69L2.5 69L2.5 75L3 75L3.5 75L3.5 69L3 69ZM3 81L2.5 81L2.5 87L3 87L3.5 87L3.5 81L3 81ZM3 93L2.5 93L2.5 99L3 99L3.5 99L3.5 93L3 93ZM2.99999 105L2.49999 105L2.49999 111L2.99999 111L3.49999 111L3.49999 105L2.99999 105ZM2.99999 117L2.49999 117L2.49999 123L2.99999 123L3.49999 123L3.49999 117L2.99999 117ZM2.99999 129L2.49999 129L2.49999 135L2.99999 135L3.49999 135L3.49999 129L2.99999 129ZM2.99999 141L2.49999 141L2.49999 144L2.99999 144L3.49999 144L3.49999 141L2.99999 141Z"
                    fill="#0391F0"/>
                </svg>
                <div className='mt-[13px] text-body1 text-label-300'>
                  자동화된<br/>
                  사고 신고 프로세스에 따른<br/>
                  접수 시간 개선
                </div>
              </motion.div>

              <motion.div
                className='ml-[185px]'
                initial='init'
                animate={descriptionControls[2]}
                variants={descriptionVariants}
              >
                <svg width="6" height="147" viewBox="0 0 6 147" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2.99999 141.333C1.52723 141.333 0.333326 142.527 0.333326 144C0.333326 145.473 1.52723 146.667 2.99999 146.667C4.47275 146.667 5.66666 145.473 5.66666 144C5.66666 142.527 4.47275 141.333 2.99999 141.333ZM3 0L2.5 -1.96701e-08L2.5 3L3 3L3.5 3L3.5 1.96701e-08L3 0ZM3 9L2.5 9L2.5 15L3 15L3.5 15L3.5 9L3 9ZM3 21L2.5 21L2.5 27L3 27L3.5 27L3.5 21L3 21ZM3 33L2.5 33L2.5 39L3 39L3.5 39L3.5 33L3 33ZM3 45L2.5 45L2.5 51L3 51L3.5 51L3.5 45L3 45ZM3 57L2.5 57L2.5 63L3 63L3.5 63L3.5 57L3 57ZM3 69L2.5 69L2.5 75L3 75L3.5 75L3.5 69L3 69ZM3 81L2.5 81L2.5 87L3 87L3.5 87L3.5 81L3 81ZM3 93L2.5 93L2.5 99L3 99L3.5 99L3.5 93L3 93ZM2.99999 105L2.49999 105L2.49999 111L2.99999 111L3.49999 111L3.49999 105L2.99999 105ZM2.99999 117L2.49999 117L2.49999 123L2.99999 123L3.49999 123L3.49999 117L2.99999 117ZM2.99999 129L2.49999 129L2.49999 135L2.99999 135L3.49999 135L3.49999 129L2.99999 129ZM2.99999 141L2.49999 141L2.49999 144L2.99999 144L3.49999 144L3.49999 141L2.99999 141ZM2.99999 141.333C1.52723 141.333 0.333326 142.527 0.333326 144C0.333326 145.473 1.52723 146.667 2.99999 146.667C4.47275 146.667 5.66666 145.473 5.66666 144C5.66666 142.527 4.47275 141.333 2.99999 141.333ZM3 0L2.5 -1.96701e-08L2.5 3L3 3L3.5 3L3.5 1.96701e-08L3 0ZM3 9L2.5 9L2.5 15L3 15L3.5 15L3.5 9L3 9ZM3 21L2.5 21L2.5 27L3 27L3.5 27L3.5 21L3 21ZM3 33L2.5 33L2.5 39L3 39L3.5 39L3.5 33L3 33ZM3 45L2.5 45L2.5 51L3 51L3.5 51L3.5 45L3 45ZM3 57L2.5 57L2.5 63L3 63L3.5 63L3.5 57L3 57ZM3 69L2.5 69L2.5 75L3 75L3.5 75L3.5 69L3 69ZM3 81L2.5 81L2.5 87L3 87L3.5 87L3.5 81L3 81ZM3 93L2.5 93L2.5 99L3 99L3.5 99L3.5 93L3 93ZM2.99999 105L2.49999 105L2.49999 111L2.99999 111L3.49999 111L3.49999 105L2.99999 105ZM2.99999 117L2.49999 117L2.49999 123L2.99999 123L3.49999 123L3.49999 117L2.99999 117ZM2.99999 129L2.49999 129L2.49999 135L2.99999 135L3.49999 135L3.49999 129L2.99999 129ZM2.99999 141L2.49999 141L2.49999 144L2.99999 144L3.49999 144L3.49999 141L2.99999 141Z"
                    fill="#0391F0"/>
                </svg>
                <div className='mt-[13px] text-body1 text-label-300'>
                  정확한 사고 위치<br/>
                  확인에 따른<br/>
                  현장 도착 시간 개선<br/>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}

